/**
 * Synchronizes text-and-image component heights.
 */
document.addEventListener('DOMContentLoaded', function() {
  function updateHeights() {
    if (window.innerWidth > 1024) {
      const blocks = document.querySelectorAll('.text-image-block__container');
      blocks.forEach(function(block) {
        const textContainer = block.querySelector('.text-image-block__text-wrapper');
        const imageContainer = block.querySelector('.text-image-block__image');
        if (textContainer && imageContainer) {
          const height = textContainer.offsetHeight;
          imageContainer.style.height = height + 'px';
        }
      });
    } else {
      // Reset the image container height if below 1024px (or adjust as desired)
      const blocks = document.querySelectorAll('.text-image-block');
      blocks.forEach(function(block) {
        const imageContainer = block.querySelector('.text-image-block__image');
        if (imageContainer) {
          imageContainer.style.height = '';
        }
      });
    }
  }
  
  updateHeights();
  window.addEventListener('resize', updateHeights);
});